import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useEffect, useState } from 'react';
import { IAccessControlPermission } from 'wisestep-api';

export interface IPermissionControlChild {
  permission: IAccessControlPermission;
  checked: boolean;
  headerChecked: boolean;
  headerIndeterminate: boolean;
  handleChangeEventChildRow: (
    data: IAccessControlPermission,
    event: React.ChangeEvent<HTMLInputElement>
  ) => void;
}

const PermissionControlChild = ({
  permission,
  checked,
  headerChecked,
  headerIndeterminate,
  handleChangeEventChildRow,
}: IPermissionControlChild) => {
  const [isChecked, setChecked] = useState(checked);
  useEffect(() => {
    setChecked(checked);
    if (!headerIndeterminate) {
      setChecked(headerChecked);
    }
  }, [headerChecked, headerIndeterminate, checked]);
  return (
    <FormControlLabel
      label=""
      control={
        <Checkbox
          checked={isChecked}
          onChange={(event) => {
            setChecked(event?.target.checked);
            handleChangeEventChildRow(permission, event);
          }}
        />
      }
    />
  );
};

export default PermissionControlChild;
